

























































































import {Component, Ref} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsExplorer from "@/design-system/patterns/Explorer/JdsExplorer.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdiCodeBlock from "@/components/JdiCodeBlock.vue"

@Component({
    components: {
        JdiCodeBlock, JdsExplorer, JdiDocs, JdsButton, JdiContent, JdiPreview}
})
export default class Explorer extends Vue {
    @Ref() explorerEl!: JdsExplorer

    open () {
        this.explorerEl.open().catch(()=>{});
    }
}
